import api from "../fetch/api";


/**
 * 页面接口
 */
export default {
  test(params) {
    return api.get('static/jsonData/myTravel.json', params)
  },

  //图片上传
  upLoad(params) {
    return api.upLoadService('/sys/attach/upLoad', params)
  },
  /**
   * 宿舍联合查询功能
   */
  //获取年级
  gradeList(params) {
    return api.get('/wx/dorm/nation/grade/list', params)
  },
  //获取民族
  nationList(params) {
    return api.get('/wx/dorm/nation/nations/list', params)
  },
  //查询数据
  nationSearch(params) {
    return api.get('/wx/dorm/nation/search', params)
  },
  //权限查询
  checkPermission(params) {
    return api.get('/wx/dorm/nation/checkPermission', params)
  },
  //统一认证请求
  serviceValidate(params) {
    return api.get('/sso/serviceValidate', params)
  },
  /**
   * 学生房间管理统计查询
   */
  //查看权限
  roomCheckPermission(params) {
    return api.get('/wx/room/mg/checkPermission', params)
  },
  //统计宿舍楼区域分布情况
  findDormAreaFbList(params) {
    return api.get('/wx/room/mg/findDormAreaFbList', params)
  },
  //统计学生住房比重
  roomZfbz(params) {
    return api.get('/wx/room/mg/zfbz', params)
  },
  //统计宿学院人数分布情况和住房人数分布情况
  findStudentsFbqk(params) {
    return api.get('/wx/room/mg/findStudentsFbqk', params)
  },
  //统计宿舍每一栋楼栋的入住情况
  findLdDetail(params) {
    return api.get('/wx/room/mg/findLdDetail', params)
  },
  /**
   * 学院入住查询
   */
  //学院入住查询初始化页面查询
  collegeQueryInit(params) {
    return api.get('/wx/inroom/query/tab1/collegeQueryInit', params)
  },
  //学院入住查询第一个列表界面
  findInRoomByCollegeList(params) {
    return api.get('/wx/inroom/query/tab1/findInRoomByCollegeList', params)
  },
  //学院入住查询第二个列表界面
  findInRoomByCollegeInOutRercods(params) {
    return api.get('/wx/inroom/query/tab1/findInRoomByCollegeInOutRercods', params)
  },
  //学院入住查询第三个列表界面
  findInRoomQueryTjByCollege(params) {
    return api.get('/wx/inroom/query/tab1/findInRoomQueryTjByCollege', params)
  },
  /**
   * 楼栋入住查询
   */
  //楼栋入住查询初始化页面查询
  dormQueryInit(params) {
    return api.get('/wx/inroom/query/tab2/dormQueryInit', params)
  },
  //楼栋入住查询第一个列表界面
  findInRoomByDormList(params) {
    return api.get('/wx/inroom/query/tab2/findInRoomByDormList', params)
  },
  //楼栋入住查询第二个列表界面
  findInRoomByDormInOutRercods(params) {
    return api.get('/wx/inroom/query/tab2/findInRoomByDormInOutRercods', params)
  },
  //楼栋入住查询第三个列表界面
  findInRoomQueryTjByDorm(params) {
    return api.get('/wx/inroom/query/tab1/findInRoomQueryTjByDorm', params)
  },
  /**
   * 综合入住查询
   */
  //综合入住查询第一个界面指标
  findInRoomStudentZHTarget(params) {
    return api.get('/wx/inroom/query/tab3/findInRoomStudentZHTarget', params)
  },
  //综合入住查询第一个界面学院指标
  findInRoomStudentZHCollegeTarget(params) {
    return api.get('/wx/inroom/query/tab3/findInRoomStudentZHCollegeTarget', params)
  },
  //综合入住查询第二个界面进出记录
  findInRoomStudentZHInOutRecord(params) {
    return api.get('/wx/inroom/query/tab3/findInRoomStudentZHInOutRecord', params)
  },
  //综合入住查询第三个界面入住学生信息
  findInRoomStudentZHStudentMsg(params) {
    return api.get('/wx/inroom/query/tab3/findInRoomStudentZHStudentMsg', params)
  },

  /**
   * 综合入住查询
   */
  //社区老师查询学生
  findStudent(params) {
    return api.get('/wx/changeRoom/sq/findStudent', params)
  },
  //社区老师查询申请记录
  applyRecords(params) {
    return api.get('/wx/changeRoom/sq/applyRecords', params)
  },
  //社区老师查询自己所管辖的宿舍楼栋
  findOwnDorm(params) {
    return api.get('/wx/changeRoom/sq/findOwnDorm', params)
  },
  //根据楼栋id查询一栋楼未住满的房间
  findNotFullInRoomByAreaId(params) {
    return api.get('/wx/changeRoom/sq/findNotFullInRoomByAreaId', params)
  },
  //根据寝室id查询这个寝室的入住的人员信息
  findNotFullInRoomPersons(params) {
    return api.get('/wx/changeRoom/sq/findNotFullInRoomPersons', params)
  },
  //社区老师提交申请
  sqApply(params) {
    return api.get('/wx/changeRoom/sq/apply', params)
  },
  //后勤老师查询待办记录
  findWaitDatasForHq(params) {
    return api.get('/wx/changeRoom/audit/findWaitDatasForHq', params)
  },
  //后勤老师查询审核历史
  findAuditHistoryForHq(params) {
    return api.get('/wx/changeRoom/audit/findAuditHistoryForHq', params)
  },
  //物业老师查询审核历史
  findAuditHistoryForWy(params) {
    return api.get('/wx/changeRoom/audit/findAuditHistoryForWy', params)
  },
  //物业老师查询待办
  findWaitForWy(params) {
    return api.get('/wx/changeRoom/audit/findWaitForWy', params)
  },
  //舍区老师宿舍管理页面
  findSqTeacherAttend(params) {
    return api.get('/api/sqTeacher/attend/findSqTeacherAttend', params)
  },

  /**
   * 网络报修
   */
  //初始化申报界面
  initMaintainIndex(params) {
    return api.get('/api/NetworkMaintain/initMaintainIndex', params)
  },
  //报修申报
  maintainApply(params) {
    return api.post('/api/NetworkMaintain/maintainApply', params)
  },
  //我的报修列表界面
  myNetWorkMaintain(params) {
    return api.get('/api/NetworkMaintain/myNetWorkMaintain', params)
  },
  //我的报修详情界面
  myNetWorkMaintainDetail(params) {
    return api.get('/api/NetworkMaintain/myNetWorkMaintainDetail', params)
  },
  //维修管理-维修单详情
  repairOrderDetail(params) {
    return api.get('/api/NetworkMaintain/repairOrderDetail', params)
  },
  //获取故障类别
  findErrorType(params) {
    return api.get('/api/NetworkMaintain/findErrorType', params)
  }
}


// WEBPACK FOOTER //
// ./src/fetch/service.js